import type { MutableRefObject } from "react";
import { ReasonForm } from "./ReasonForm";

const localeRoot =
  "community_onboarding.new_checklist.email_broadcast_survey_modal";

const reasonKeys = [
  "use_different_tool",
  "missing_something",
  "too_expensive",
  "come_back_later",
  "i_do_not_send_emails",
  "other",
];

interface EmailBroadcastSurveyFormProps {
  onSubmit: () => void;
  triggerFormSubmitRef?: MutableRefObject<(() => Promise<void>) | null>;
}

export const EmailBroadcastSurveyForm = ({
  onSubmit,
  triggerFormSubmitRef,
}: EmailBroadcastSurveyFormProps) => (
  <ReasonForm
    eventType="checklist.email_broadcast_survey.reason.submitted"
    localeRoot={localeRoot}
    reasonKeys={reasonKeys}
    onSubmit={onSubmit}
    triggerFormSubmitRef={triggerFormSubmitRef}
  />
);
